import { get, post, put } from './client';

export function getOrganizations() {
  return get('/organizations');
}

export function getOrganizationsForUser() {
  return get('/organizations/user');
}

export function getEnterprises() {
  return get('/enterprises');
}

export function getContractTypes() {
  return get('/contract-types');
}

export function getOrganization(organizationId) {
  return get(`/organizations/${organizationId}`);
}

export function saveOrganization(organization) {
  const formData = new FormData();

  if (organization.logo) {
    formData.append('logo', organization.logo, organization.logo?.name);
  } else {
    formData.append('logo', organization.logo);
  }
  formData.append('name', organization.name);
  formData.append('isActive', organization.isActive);
  formData.append('enterprise', organization.enterprise?.id);
  formData.append('suretechAccountNumber', organization.suretechAccountNumber);
  formData.append(
    'contractTypes',
    (organization.contractTypes || [])
      .map((contractType) => contractType.id)
      .join(','),
  );

  return organization.id
    ? updateOrganization(organization, formData)
    : createOrganization(formData);
}

function createOrganization(formData) {
  return post('/organizations', formData);
}

async function updateOrganization(organization, formdata) {
  return put(`/organizations/${organization.id}`, formdata);
}
